import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-contract-type-filter',
  templateUrl: './contract-type-filter.component.html',
  styleUrls: ['./contract-type-filter.component.scss']
})
export class ContractTypeFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listContractTypeFilter: any[];
  optionSelected: any;

  @Input() contractTypeData: any;
  @Input() contractTypeSelected: ContractTypeModel;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('contractTypeData' in changes) {
      this.listContractTypeFilter = this.contractTypeData ? this.contractTypeData : [];
      this.optionSelected = null;
    }
    if (this.contractTypeSelected) {
      this.optionSelected = this.contractTypeSelected;
    }
  }

  ngOnDestroy(): void {
  }

}
